// Fakturaliste (no).
window.PlummeI18n.register('no', {
  // ------------------------------------------------------------ Fakturaliste
  'inv.title': 'Fakturaliste',
  'inv.titleHelp': 'Oversikt over fakturaer, tilbud, ordrebekreftelser og kreditnotaer for valgt regnskapsår.',
  'inv.searchPh': 'Søk på fakturanummer, kunde eller beløp',
  'inv.searchHelp': 'Søk i listen på fakturanummer, kundenavn, fakturabeløp, nettobeløp, betalt beløp eller restbeløp.',
  'inv.rows.searchHelp': 'Søk på starten av fakturanummeret eller kundenavnet. Bruk id: etterfulgt av nøyaktig dokument-ID for direkte oppslag. Valgt periode og øvrige filtre gjelder fortsatt.',
  'inv.rows.searchPh': 'Fakturanummer, kunde eller id:dokument-ID',
  'inv.downloadHelp': 'Last ned listen for fanen og filteret du har valgt.',
  'inv.addHelp': 'Lag en ny faktura.',
  'inv.add': 'Ny faktura',
  'inv.filterHelp': 'Filtrer listen på status, dokumenttype, dato, periode, beløp og arkiv.',
  'inv.tabsHelpTitle': 'Dokumenttyper',
  'inv.tabsHelp': 'Bytt mellom Faktura, Utkast, Tilbud/Ordrebekreftelse, Kreditnota og Salgsrapport.',
  'inv.listHelpTitle': 'Fakturalisten',
  'inv.listHelp': 'Hver rad er ett dokument fra backend. Trykk på en rad for detaljer og handlinger.',
  'inv.loading': 'Laster fakturaer',
  'inv.loadingSub': 'Henter data fra backend.',
  'inv.noMatch': 'Ingen treff her',
  'inv.noMatchSub': 'Prøv en annen fane eller nullstill filteret.',
  'inv.rows.showing': 'Viser {shown} av {total}',
  'inv.rows.shown': 'Viser {shown}',
  'inv.rows.pageOf': 'Denne siden: {shown} av {total} treff',
  'inv.rows.pageShown': 'Denne siden: {shown} treff',
  'inv.rows.pageScope': 'Sortering, utvalg og listeeksport gjelder denne siden. Filtre kan gi tomme sider; bruk Neste eller Forrige for å fortsette.',
  'inv.rows.pageFileSuffix': '-denne-siden',
  'inv.rows.previous': 'Forrige',
  'inv.rows.next': 'Neste',
  'inv.rows.first': 'Oppdater fra starten',
  'inv.rows.retry': 'Prøv igjen',
  'inv.rows.pageError': 'Kunne ikke laste siden. Prøv igjen eller oppdater fra starten.',
  'inv.rows.loadMore': 'Last inn flere',
  'inv.rows.loadingMore': 'Laster …',
  'inv.backToVouchers': 'Tilbake til transaksjoner',

  // Dokumenttyper. Segmentet speiler `invoice.type` i Firestore.
  'inv.type.invoice': 'Faktura',
  'inv.type.quote': 'Tilbud',
  'inv.type.orderConfirmation': 'Ordrebekreftelse',
  'inv.type.creditNote': 'Kreditnota',
  'inv.type.unknown': 'Dokument',
  'inv.tab.salesReport': 'Salgsrapport',
  'inv.importHistory.tab': 'Importert historikk',
  'inv.importHistory.loading': 'Henter importert fakturahistorikk …',
  'inv.importHistory.error': 'Kunne ikke hente importert fakturahistorikk.',
  'inv.importHistory.readOnly': 'Dette er skrivebeskyttet historikk fra det tidligere systemet. Postene påvirker ikke bokføring eller MVA og har ingen fakturahandlinger i Plumme.',
  'inv.importHistory.documents': 'Dokumenter',
  'inv.importHistory.year': 'Importert historikk for {year}',
  'inv.importHistory.netSales': 'Netto salg',
  'inv.importHistory.customers': 'Kunder',
  'inv.importHistory.creditNotes': 'Kreditnotaer',
  'inv.importHistory.netIncluded': 'Trukket fra netto salg',
  'inv.importHistory.search': 'Søk på fakturanummer eller kunde',
  'inv.importHistory.empty': 'Ingen importerte fakturadetaljer for dette året',
  'inv.importHistory.emptySub': 'Importerte regnskapstall brukes fortsatt i rapporter og råd når de finnes.',
  'inv.importHistory.detailTitle': 'Detaljer fra importfilen',
  'inv.importHistory.dueDate': 'Forfallsdato',
  'inv.importHistory.paidDate': 'Oppgjort dato',
  'inv.importHistory.remaining': 'Utestående',
  'inv.importHistory.lines': 'Importerte linjer',
  'inv.importHistory.noLines': 'Kildesystemet leverte bare fakturatotaler for dette dokumentet.',
  'inv.importHistory.markSettled': 'Marker som oppgjort',
  'inv.importHistory.reopenStatus': 'Åpne status igjen',
  'inv.importHistory.manualSettledNote': 'Markert oppgjort i Plumme uten regnskapsføring.',
  'inv.importHistory.settledToast': 'Importert faktura er markert som oppgjort.',
  'inv.importHistory.reopenedToast': 'Importert faktura er åpnet igjen.',
  'inv.importHistory.statusError': 'Kunne ikke oppdatere importert faktura.',
  'inv.importHistory.sourceNote': 'Importert fra tidligere system – dokumentet ligger i importfilen.',
  'inv.importHistory.creditReference': 'Importert kreditnota fra tidligere system – krediterer faktura {number}.',
  'inv.importHistory.creditedReference': 'Importert fra tidligere system · kreditert med kreditnota {number}',
  'inv.importHistory.reanalysisTitle': 'Importert fakturahistorikk må analyseres på nytt',
  'inv.importHistory.reanalysisBody': 'Den lagrede analysen er fra før kreditnotaer ble hentet fra egne kreditnota-ark. Kildedataene endres ikke.',
  'inv.importHistory.reanalysisAction': 'Gå til reanalyse',
  'inv.importHistory.rowSource': 'Importert fra tidligere system',
  'adv.sales.importedHistoryNote': 'Analysen kombinerer bokførte Plumme-fakturaer med skrivebeskyttet salgshistorikk fra importen. Kreditnotaer er trukket fra. {coverage}',
  'adv.sales.importedTotalsCoverage': 'Importen inneholder fakturatotaler, men ikke produktlinjer for alle dokumentene.',
  'adv.sales.importedLinesCoverage': 'Importen inneholder også fakturalinjer for deler av historikken.',
  'inv.tab.drafts': 'Utkast',
  'inv.filterDocType': 'Dokumenttype',
  'inv.filterArchive': 'Arkiv',
  'inv.filterSeeArchived': 'Se arkiverte',

  // Statusetiketter i fakturalisten. Segmentet speiler `invoice.status`.
  'inv.status.draft': 'Utkast',
  'inv.status.created': 'Ikke sendt',
  'inv.status.sent': 'Sendt',
  'inv.status.accepted': 'Akseptert',
  'inv.status.confirmed': 'Bekreftet',
  'inv.status.paid': 'Betalt',
  'inv.status.unpaid': 'Ikke betalt',
  'inv.status.overdue': 'Forfalt',
  'inv.status.credited': 'Kreditert',

  // KPI-kortene. Id-ene er stabile; hjelpeteksten slås opp på samme id.
  'inv.kpi.invoiceCount': 'Fakturaer',
  'inv.kpi.invoiceCount.help': 'Antall fakturaer du har laget i det valgte året, uansett status.',
  'inv.kpi.revenue': 'Omsetning',
  'inv.kpi.revenue.help': 'Sum av alle fakturaer eksklusiv MVA i året.',
  'inv.kpi.notSent': 'Ikke sendt',
  'inv.kpi.notSent.help': 'Fakturaer som ligger som utkast og venter på å bli sendt.',
  'inv.kpi.credited': 'Kreditert',
  'inv.kpi.credited.help': 'Antall kreditnotaer.',
  'inv.kpi.quotes': 'Tilbud',
  'inv.kpi.quotes.help': 'Antall tilbud i året.',
  'inv.kpi.accepted': 'Akseptert',
  'inv.kpi.accepted.help': 'Antall tilbud som kunden har akseptert.',
  'inv.kpi.orders': 'Ordrebekreftelser',
  'inv.kpi.orders.help': 'Antall ordrebekreftelser i året.',
  'inv.kpi.creditNotes': 'Kreditnotaer',
  'inv.kpi.creditNotes.help': 'Antall kreditnotaer i året.',
  'inv.kpi.value': 'Verdi',
  'inv.kpi.value.help': 'Samlet verdi eksklusiv MVA for dokumentene i denne fanen.',
  'inv.kpi.amount': 'Beløp',
  'inv.kpi.amount.help': 'Samlet beløp eksklusiv MVA for kreditnotaene.',
  'inv.kpi.sent': 'Sendt',
  'inv.kpi.sent.help': 'Antall dokumenter som er sendt til kunden.',
  'inv.kpi.confirmed': 'Bekreftet',
  'inv.kpi.confirmed.help': 'Ordrebekreftelser kunden har bekreftet.',
  'inv.kpi.drafts': 'Utkast',
  'inv.kpi.drafts.help': 'Dokumenter som ennå ikke er sendt.',
  'inv.kpi.potentialRevenue': 'Mulig omsetning',
  'inv.kpi.potentialRevenue.help': 'Samlet verdi av utkast som kan bli sendt.',
  'inv.kpi.customers': 'Kunder',
  'inv.kpi.customers.help': 'Antall unike kunder på utkastene.',
  'inv.kpi.history': 'Historikk',
  'inv.kpi.history.help': 'Hvor lenge eldste utkast har ventet.',
  'inv.kpi.sub.totalYear': 'Totalt i år',
  'inv.kpi.sub.exVat': 'Eks. MVA',
  'inv.kpi.sub.waiting': 'Venter på deg',
  'inv.kpi.sub.creditNotes': 'Kreditnotaer',
  'inv.kpi.sub.started': 'Påbegynte dokumenter',
  'inv.kpi.sub.uniqueCustomers': 'Unike kunder',
  'inv.kpi.sub.oldestDraft': 'Eldste utkast',
  'inv.kpi.sub.noDrafts': 'Ingen utkast',
  'inv.kpi.sub.none': 'Ingen',
  'inv.kpi.sub.days': '{n} dager',
  'inv.kpi.sub.sentQuotes': 'Sendte tilbud',
  'inv.kpi.sub.accepted': 'Aksepterte',
  'inv.kpi.sub.confirmed': 'Bekreftede',
  'inv.kpi.sub.notSent': 'Ikke sendt',
  'inv.kpi.sub.sent': 'Sendte',

  'inv.col.document': 'Dokument',
  'inv.col.invoice': 'Faktura',
  'inv.col.date': 'Dato',
  'inv.col.net': 'Netto',
  'inv.col.amount': 'Beløp',
  'inv.col.status': 'Status',
  'inv.col.number': 'Nr',
  'inv.col.customer': 'Kunde',
  'inv.netInline': 'Netto {amount}',
  'inv.draftPlaceholder': 'UTKAST',

  // Detaljvisning
  'inv.detail.dueTitle': 'Forfall',
  'inv.detail.dueHelp': 'Datoen dokumentet gjelder til eller skal være betalt innen.',
  'inv.detail.statusHelp': 'Betalinger hentes fra bokførte PaymentEntry-poster. Tilbud og ordrebekreftelser viser gjennomføringsstatus.',
});
